// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMIndicator-module__font-s-10___IWK32 {
  font-size: 10px !important;
}

.CGMIndicator-module__font-s-12___XnRAW {
  font-size: 12px !important;
}

.CGMIndicator-module__font-s-13___qytK2 {
  font-size: 13px !important;
}

.CGMIndicator-module__font-s-14___swe4s {
  font-size: 14px !important;
}

.CGMIndicator-module__font-s-15___Qk7Ix {
  font-size: 15px !important;
}

.CGMIndicator-module__font-s-16___etzR_ {
  font-size: 16px !important;
}

.CGMIndicator-module__font-s-18___kaoG8 {
  font-size: 18px !important;
}

.CGMIndicator-module__font-s-20___nii9M {
  font-size: 20px !important;
}

.CGMIndicator-module__font-s-22___RUswF {
  font-size: 22px !important;
}

.CGMIndicator-module__font-s-28___QgQ0W {
  font-size: 28px !important;
}

.CGMIndicator-module__font-w-400___WBcgf {
  font-weight: 400 !important;
}

.CGMIndicator-module__font-w-500___Gs8Sc {
  font-weight: 500 !important;
}

.CGMIndicator-module__font-w-600___gY31g {
  font-weight: 600 !important;
}

.CGMIndicator-module__font-w-700___ee9QF {
  font-weight: 700 !important;
}

.CGMIndicator-module__p-5___tgKDO {
  padding: 5px !important;
}

.CGMIndicator-module__p-12___SvL3A {
  padding: 12px !important;
}

.CGMIndicator-module__p-16___wDuu2 {
  padding: 16px !important;
}

.CGMIndicator-module__p-30___wXbGX {
  padding: 30px !important;
}

.CGMIndicator-module__p-b-0___Tynd1 {
  padding-bottom: 0 !important;
}

.CGMIndicator-module__p-b-5___euesK {
  padding-bottom: 5px !important;
}

.CGMIndicator-module__p-b-10___X8uUp {
  padding-bottom: 10px !important;
}

.CGMIndicator-module__p-b-12___NrYMD {
  padding-bottom: 12px !important;
}

.CGMIndicator-module__p-b-16___Bhchp {
  padding-bottom: 16px !important;
}

.CGMIndicator-module__p-b-18___gOZ93 {
  padding-bottom: 18px !important;
}

.CGMIndicator-module__p-b-20___mDpvV {
  padding-bottom: 20px !important;
}

.CGMIndicator-module__p-b-25___F7Rfg {
  padding-bottom: 25px !important;
}

.CGMIndicator-module__p-b-30___cL0Sa {
  padding-bottom: 30px !important;
}

.CGMIndicator-module__p-b-50___aQwZg {
  padding-bottom: 50px !important;
}

.CGMIndicator-module__p-t-0___iYHVz {
  padding-top: 0 !important;
}

.CGMIndicator-module__p-t-12___j8hBV {
  padding-top: 12px !important;
}

.CGMIndicator-module__p-t-16___GoC5G {
  padding-top: 16px !important;
}

.CGMIndicator-module__p-t-18___eO5DV {
  padding-top: 18px !important;
}

.CGMIndicator-module__p-t-20___g6Lav {
  padding-top: 20px !important;
}

.CGMIndicator-module__p-t-30___jMkmt {
  padding-top: 30px !important;
}

.CGMIndicator-module__p-t-40___FQzCt {
  padding-top: 40px !important;
}

.CGMIndicator-module__p-t-50___eSTqO {
  padding-top: 50px !important;
}

.CGMIndicator-module__p-l-20___TOIoW {
  padding-left: 20px !important;
}

.CGMIndicator-module__p-l-30___IofR3 {
  padding-left: 30px !important;
}

.CGMIndicator-module__p-l-40___X5q2t {
  padding-left: 40px !important;
}

.CGMIndicator-module__p-r-16___iaqMe {
  padding-right: 16px !important;
}

.CGMIndicator-module__p-r-20___SSNAX {
  padding-right: 20px !important;
}

.CGMIndicator-module__p-r-30___WRRd6 {
  padding-right: 30px !important;
}

.CGMIndicator-module__p-r-50___Ickvh {
  padding-right: 50px !important;
}

.CGMIndicator-module__p-r-60___jbeS6 {
  padding-right: 60px !important;
}

.CGMIndicator-module__m-b-1___cELWT {
  margin-bottom: 1px !important;
}

.CGMIndicator-module__m-b-2___VMiFR {
  margin-bottom: 2px !important;
}

.CGMIndicator-module__m-b-6___cfOqE {
  margin-bottom: 6px !important;
}

.CGMIndicator-module__m-b-8___H3EXp {
  margin-bottom: 8px !important;
}

.CGMIndicator-module__m-b-10___Mh97w {
  margin-bottom: 10px !important;
}

.CGMIndicator-module__m-b-14___xS8oo {
  margin-bottom: 14px !important;
}

.CGMIndicator-module__m-b-16___wqhXN {
  margin-bottom: 16px !important;
}

.CGMIndicator-module__m-b-20___INtyL {
  margin-bottom: 20px !important;
}

.CGMIndicator-module__m-b-22___SWyC9 {
  margin-bottom: 22px !important;
}

.CGMIndicator-module__m-b-24___EQ4Bt {
  margin-bottom: 24px !important;
}

.CGMIndicator-module__m-b-30___jwCL8 {
  margin-bottom: 30px !important;
}

.CGMIndicator-module__m-b-32___Mm_pF {
  margin-bottom: 32px !important;
}

.CGMIndicator-module__m-b-40___ByJBp {
  margin-bottom: 40px !important;
}

.CGMIndicator-module__m-t-2___giuQ6 {
  margin-top: 2px !important;
}

.CGMIndicator-module__m-t-3___ZBU_7 {
  margin-top: 3px !important;
}

.CGMIndicator-module__m-t-4___lFPFN {
  margin-top: 4px !important;
}

.CGMIndicator-module__m-t-5___s5g3Y {
  margin-top: 5px !important;
}

.CGMIndicator-module__m-t-8___GemVm {
  margin-top: 8px !important;
}

.CGMIndicator-module__m-t-10___GWXKT {
  margin-top: 10px !important;
}

.CGMIndicator-module__m-t-15___D_Ao1 {
  margin-top: 15px !important;
}

.CGMIndicator-module__m-t-16___gyftr {
  margin-top: 16px !important;
}

.CGMIndicator-module__m-t-20___X9AEM {
  margin-top: 20px !important;
}

.CGMIndicator-module__m-t-22___sIgqb {
  margin-top: 22px !important;
}

.CGMIndicator-module__m-t-30___oVjUt {
  margin-top: 30px !important;
}

.CGMIndicator-module__m-t-32___biTeB {
  margin-top: 32px !important;
}

.CGMIndicator-module__m-l-auto___CFwk3 {
  margin-left: auto !important;
}

.CGMIndicator-module__m-l-4___manTh {
  margin-left: 4px !important;
}

.CGMIndicator-module__m-l-5___hm0aE {
  margin-left: 5px !important;
}

.CGMIndicator-module__m-l-6___fj6No {
  margin-left: 6px !important;
}

.CGMIndicator-module__m-l-8___VUfji {
  margin-left: 8px !important;
}

.CGMIndicator-module__m-l-10___HfvZG {
  margin-left: 10px !important;
}

.CGMIndicator-module__m-l-16___IOjfY {
  margin-left: 16px !important;
}

.CGMIndicator-module__m-l-20___HdIXQ {
  margin-left: 20px !important;
}

.CGMIndicator-module__m-l-24___MpyMm {
  margin-left: 24px !important;
}

.CGMIndicator-module__m-l-30___xdPYr {
  margin-left: 30px !important;
}

.CGMIndicator-module__m-l-35___ZLuaW {
  margin-left: 35px !important;
}

.CGMIndicator-module__m-l-40___tIvhx {
  margin-left: 40px !important;
}

.CGMIndicator-module__m-r-8___WXK6g {
  margin-right: 8px !important;
}

.CGMIndicator-module__m-r-10___eUbUf {
  margin-right: 10px !important;
}

.CGMIndicator-module__m-r-16___oGoD7 {
  margin-right: 16px !important;
}

.CGMIndicator-module__m-r-20____Dmcy {
  margin-right: 20px !important;
}

.CGMIndicator-module__m-r-24___GP8A2 {
  margin-right: 24px !important;
}

.CGMIndicator-module__m-r-30___BxWQ9 {
  margin-right: 30px !important;
}

.CGMIndicator-module__m-r-40___hE1_R {
  margin-right: 40px !important;
}

.CGMIndicator-module__border-r-3___wyvyz {
  border-radius: 3px !important;
}

.CGMIndicator-module__border-r-4___VV6dv {
  border-radius: 4px !important;
}

.CGMIndicator-module__border-r-6___wtRl2 {
  border-radius: 6px !important;
}

.CGMIndicator-module__border-r-10___dmhvF {
  border-radius: 10px !important;
}

.CGMIndicator-module__border-r-12___N1Goh {
  border-radius: 12px !important;
}

.CGMIndicator-module__border-r-16___Xjsbt {
  border-radius: 16px !important;
}

.CGMIndicator-module__border-r-50___c_feZ {
  border-radius: 50% !important;
}

.CGMIndicator-module__primary-border___FAJeE {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMIndicator-module__primary-border-b___CebIr {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMIndicator-module__primary-border-t___sFMPB {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMIndicator-module__primary-border-l___cS4RT {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMIndicator-module__primary-border-r___NxEJ0 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMIndicator-module__secondary-border___e3bSq {
  border: 1px solid #637768;
}

.CGMIndicator-module__secondary-border-b___iO1oq {
  border-bottom: 1px solid #637768;
}

.CGMIndicator-module__secondary-border-t___fFl4Q {
  border-top: 1px solid #637768;
}

.CGMIndicator-module__secondary-border-l___TXMMT {
  border-left: 1px solid #637768;
}

.CGMIndicator-module__secondary-border-r___c8jfm {
  border-right: 1px solid #637768;
}

.CGMIndicator-module__gap-0___KdONx {
  gap: 0 !important;
}

.CGMIndicator-module__gap-2___BOQtM {
  gap: 2px !important;
}

.CGMIndicator-module__gap-4___cm0H5 {
  gap: 4px !important;
}

.CGMIndicator-module__gap-5___WCQtF {
  gap: 5px !important;
}

.CGMIndicator-module__gap-6___xzEzH {
  gap: 6px !important;
}

.CGMIndicator-module__gap-8___5aLEU {
  gap: 8px !important;
}

.CGMIndicator-module__gap-10___djpbf {
  gap: 10px !important;
}

.CGMIndicator-module__gap-12___i1UhS {
  gap: 12px !important;
}

.CGMIndicator-module__gap-14___awzzt {
  gap: 14px !important;
}

.CGMIndicator-module__gap-16___YwyR4 {
  gap: 16px !important;
}

.CGMIndicator-module__gap-18___rQ_Ho {
  gap: 18px !important;
}

.CGMIndicator-module__gap-20___vY5pB {
  gap: 20px !important;
}

.CGMIndicator-module__gap-24___E22vV {
  gap: 24px !important;
}

.CGMIndicator-module__gap-26___nd8mf {
  gap: 26px !important;
}

.CGMIndicator-module__gap-30___ccrgR {
  gap: 30px !important;
}

.CGMIndicator-module__gap-32___uV0g6 {
  gap: 32px !important;
}

.CGMIndicator-module__gap-40___oSP4U {
  gap: 40px !important;
}

.CGMIndicator-module__gap-50___2DYFu {
  gap: 50px !important;
}

.CGMIndicator-module__flex-1___MA6In {
  flex: 1;
}

.CGMIndicator-module__flex-none___qiAz1 {
  flex: none !important;
}

.CGMIndicator-module__flex-column___gCieW {
  display: flex;
  flex-direction: column !important;
}

.CGMIndicator-module__flex-row___hGaOQ {
  display: flex;
  flex-direction: row !important;
}

.CGMIndicator-module__vertically-centered___xOBPS {
  display: flex;
  align-items: center !important;
}

.CGMIndicator-module__horizontally-centered___bJxFh {
  display: flex;
  justify-content: center !important;
}

.CGMIndicator-module__horizontally-end___e4OGx {
  display: flex;
  justify-content: end !important;
}

.CGMIndicator-module__vertically-start___dkb3p {
  display: flex;
  align-items: start !important;
}

.CGMIndicator-module__space-between___uTTxx {
  display: flex;
  justify-content: space-between !important;
}

.CGMIndicator-module__flex-wrap___W8r0m {
  flex-wrap: wrap !important;
}

.CGMIndicator-module__height-100___xhhu0 {
  height: 100%;
}

.CGMIndicator-module__width-50___X4pZm {
  width: 50% !important;
}

.CGMIndicator-module__width-100___vz5j7 {
  width: 100%;
}

.CGMIndicator-module__cursor-pointer___GrTTl {
  cursor: pointer;
}

.CGMIndicator-module__cursor-not-allowed___ITs4U {
  cursor: not-allowed !important;
}

.CGMIndicator-module__absolute-centered___NvNvx {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMIndicator-module__absolute___MeO2U {
  position: absolute;
}

.CGMIndicator-module__relative___WZbYJ {
  position: relative;
}

.CGMIndicator-module__fixed___aPBCJ {
  position: fixed;
}

.CGMIndicator-module__visible___MDmlz {
  opacity: 1;
}

.CGMIndicator-module__invisible___QeBmy {
  opacity: 0;
}

.CGMIndicator-module__col-90___mx_dz {
  width: 90% !important;
}

.CGMIndicator-module__col-auto___b80SF {
  width: auto !important;
}

.CGMIndicator-module__medical-tabs___wnwyF {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMIndicator-module__medical-table-new___qlTAJ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMIndicator-module__medical-table-new___qlTAJ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMIndicator-module__medical-table-new___qlTAJ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMIndicator-module__medical-table-new___qlTAJ::-webkit-scrollbar-track {
  display: none;
}
.CGMIndicator-module__medical-table-new___qlTAJ.CGMIndicator-module__no-pagination___ox1H7 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMIndicator-module__medical-table-new___qlTAJ.CGMIndicator-module__no-pagination___ox1H7:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMIndicator-module__medical-table-new___qlTAJ.CGMIndicator-module__no-pagination___ox1H7::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMIndicator-module__medical-table-new___qlTAJ.CGMIndicator-module__no-pagination___ox1H7::-webkit-scrollbar-track {
  display: none;
}

.CGMIndicator-module__medical-table-empty___iFVrZ {
  padding: 14px 40px !important;
}

.CGMIndicator-module__icon-btn___AAws4 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMIndicator-module__search-icon___euzC2 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMIndicator-module__disable-select___Lzkhc {
  user-select: none;
}

.CGMIndicator-module__break-word___XifhK {
  word-break: break-word;
}

.CGMIndicator-module__popup-clear-btn___m4AS1 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMIndicator-module__scroll-m-b-20___W2I0U {
  scroll-margin-bottom: 20px;
}

.CGMIndicator-module__container___PmtLQ {
  background-color: #f1f6f2;
  color: #859989;
  border-radius: 47px;
  padding: 2px 8px;
}
.CGMIndicator-module__container___PmtLQ.CGMIndicator-module__critical___TCxdW {
  color: #f06c67;
  background-color: rgba(240, 108, 103, 0.1);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/items/CGMIndicator/CGMIndicator.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA8pBF;AA5pBE;EACE,cAAA;EACA,0CAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  background-color: get-color(greenNew, ultra-light);\n  color: get-color(greenNew, medium);\n  border-radius: 47px;\n  padding: 2px 8px;\n\n  &.critical {\n    color: get-color(redNew, medium-dark);\n    background-color: rgba(240, 108, 103, 0.1);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMIndicator-module__font-s-10___IWK32`,
	"fontS12": `CGMIndicator-module__font-s-12___XnRAW`,
	"fontS13": `CGMIndicator-module__font-s-13___qytK2`,
	"fontS14": `CGMIndicator-module__font-s-14___swe4s`,
	"fontS15": `CGMIndicator-module__font-s-15___Qk7Ix`,
	"fontS16": `CGMIndicator-module__font-s-16___etzR_`,
	"fontS18": `CGMIndicator-module__font-s-18___kaoG8`,
	"fontS20": `CGMIndicator-module__font-s-20___nii9M`,
	"fontS22": `CGMIndicator-module__font-s-22___RUswF`,
	"fontS28": `CGMIndicator-module__font-s-28___QgQ0W`,
	"fontW400": `CGMIndicator-module__font-w-400___WBcgf`,
	"fontW500": `CGMIndicator-module__font-w-500___Gs8Sc`,
	"fontW600": `CGMIndicator-module__font-w-600___gY31g`,
	"fontW700": `CGMIndicator-module__font-w-700___ee9QF`,
	"p5": `CGMIndicator-module__p-5___tgKDO`,
	"p12": `CGMIndicator-module__p-12___SvL3A`,
	"p16": `CGMIndicator-module__p-16___wDuu2`,
	"p30": `CGMIndicator-module__p-30___wXbGX`,
	"pB0": `CGMIndicator-module__p-b-0___Tynd1`,
	"pB5": `CGMIndicator-module__p-b-5___euesK`,
	"pB10": `CGMIndicator-module__p-b-10___X8uUp`,
	"pB12": `CGMIndicator-module__p-b-12___NrYMD`,
	"pB16": `CGMIndicator-module__p-b-16___Bhchp`,
	"pB18": `CGMIndicator-module__p-b-18___gOZ93`,
	"pB20": `CGMIndicator-module__p-b-20___mDpvV`,
	"pB25": `CGMIndicator-module__p-b-25___F7Rfg`,
	"pB30": `CGMIndicator-module__p-b-30___cL0Sa`,
	"pB50": `CGMIndicator-module__p-b-50___aQwZg`,
	"pT0": `CGMIndicator-module__p-t-0___iYHVz`,
	"pT12": `CGMIndicator-module__p-t-12___j8hBV`,
	"pT16": `CGMIndicator-module__p-t-16___GoC5G`,
	"pT18": `CGMIndicator-module__p-t-18___eO5DV`,
	"pT20": `CGMIndicator-module__p-t-20___g6Lav`,
	"pT30": `CGMIndicator-module__p-t-30___jMkmt`,
	"pT40": `CGMIndicator-module__p-t-40___FQzCt`,
	"pT50": `CGMIndicator-module__p-t-50___eSTqO`,
	"pL20": `CGMIndicator-module__p-l-20___TOIoW`,
	"pL30": `CGMIndicator-module__p-l-30___IofR3`,
	"pL40": `CGMIndicator-module__p-l-40___X5q2t`,
	"pR16": `CGMIndicator-module__p-r-16___iaqMe`,
	"pR20": `CGMIndicator-module__p-r-20___SSNAX`,
	"pR30": `CGMIndicator-module__p-r-30___WRRd6`,
	"pR50": `CGMIndicator-module__p-r-50___Ickvh`,
	"pR60": `CGMIndicator-module__p-r-60___jbeS6`,
	"mB1": `CGMIndicator-module__m-b-1___cELWT`,
	"mB2": `CGMIndicator-module__m-b-2___VMiFR`,
	"mB6": `CGMIndicator-module__m-b-6___cfOqE`,
	"mB8": `CGMIndicator-module__m-b-8___H3EXp`,
	"mB10": `CGMIndicator-module__m-b-10___Mh97w`,
	"mB14": `CGMIndicator-module__m-b-14___xS8oo`,
	"mB16": `CGMIndicator-module__m-b-16___wqhXN`,
	"mB20": `CGMIndicator-module__m-b-20___INtyL`,
	"mB22": `CGMIndicator-module__m-b-22___SWyC9`,
	"mB24": `CGMIndicator-module__m-b-24___EQ4Bt`,
	"mB30": `CGMIndicator-module__m-b-30___jwCL8`,
	"mB32": `CGMIndicator-module__m-b-32___Mm_pF`,
	"mB40": `CGMIndicator-module__m-b-40___ByJBp`,
	"mT2": `CGMIndicator-module__m-t-2___giuQ6`,
	"mT3": `CGMIndicator-module__m-t-3___ZBU_7`,
	"mT4": `CGMIndicator-module__m-t-4___lFPFN`,
	"mT5": `CGMIndicator-module__m-t-5___s5g3Y`,
	"mT8": `CGMIndicator-module__m-t-8___GemVm`,
	"mT10": `CGMIndicator-module__m-t-10___GWXKT`,
	"mT15": `CGMIndicator-module__m-t-15___D_Ao1`,
	"mT16": `CGMIndicator-module__m-t-16___gyftr`,
	"mT20": `CGMIndicator-module__m-t-20___X9AEM`,
	"mT22": `CGMIndicator-module__m-t-22___sIgqb`,
	"mT30": `CGMIndicator-module__m-t-30___oVjUt`,
	"mT32": `CGMIndicator-module__m-t-32___biTeB`,
	"mLAuto": `CGMIndicator-module__m-l-auto___CFwk3`,
	"mL4": `CGMIndicator-module__m-l-4___manTh`,
	"mL5": `CGMIndicator-module__m-l-5___hm0aE`,
	"mL6": `CGMIndicator-module__m-l-6___fj6No`,
	"mL8": `CGMIndicator-module__m-l-8___VUfji`,
	"mL10": `CGMIndicator-module__m-l-10___HfvZG`,
	"mL16": `CGMIndicator-module__m-l-16___IOjfY`,
	"mL20": `CGMIndicator-module__m-l-20___HdIXQ`,
	"mL24": `CGMIndicator-module__m-l-24___MpyMm`,
	"mL30": `CGMIndicator-module__m-l-30___xdPYr`,
	"mL35": `CGMIndicator-module__m-l-35___ZLuaW`,
	"mL40": `CGMIndicator-module__m-l-40___tIvhx`,
	"mR8": `CGMIndicator-module__m-r-8___WXK6g`,
	"mR10": `CGMIndicator-module__m-r-10___eUbUf`,
	"mR16": `CGMIndicator-module__m-r-16___oGoD7`,
	"mR20": `CGMIndicator-module__m-r-20____Dmcy`,
	"mR24": `CGMIndicator-module__m-r-24___GP8A2`,
	"mR30": `CGMIndicator-module__m-r-30___BxWQ9`,
	"mR40": `CGMIndicator-module__m-r-40___hE1_R`,
	"borderR3": `CGMIndicator-module__border-r-3___wyvyz`,
	"borderR4": `CGMIndicator-module__border-r-4___VV6dv`,
	"borderR6": `CGMIndicator-module__border-r-6___wtRl2`,
	"borderR10": `CGMIndicator-module__border-r-10___dmhvF`,
	"borderR12": `CGMIndicator-module__border-r-12___N1Goh`,
	"borderR16": `CGMIndicator-module__border-r-16___Xjsbt`,
	"borderR50": `CGMIndicator-module__border-r-50___c_feZ`,
	"primaryBorder": `CGMIndicator-module__primary-border___FAJeE`,
	"primaryBorderB": `CGMIndicator-module__primary-border-b___CebIr`,
	"primaryBorderT": `CGMIndicator-module__primary-border-t___sFMPB`,
	"primaryBorderL": `CGMIndicator-module__primary-border-l___cS4RT`,
	"primaryBorderR": `CGMIndicator-module__primary-border-r___NxEJ0`,
	"secondaryBorder": `CGMIndicator-module__secondary-border___e3bSq`,
	"secondaryBorderB": `CGMIndicator-module__secondary-border-b___iO1oq`,
	"secondaryBorderT": `CGMIndicator-module__secondary-border-t___fFl4Q`,
	"secondaryBorderL": `CGMIndicator-module__secondary-border-l___TXMMT`,
	"secondaryBorderR": `CGMIndicator-module__secondary-border-r___c8jfm`,
	"gap0": `CGMIndicator-module__gap-0___KdONx`,
	"gap2": `CGMIndicator-module__gap-2___BOQtM`,
	"gap4": `CGMIndicator-module__gap-4___cm0H5`,
	"gap5": `CGMIndicator-module__gap-5___WCQtF`,
	"gap6": `CGMIndicator-module__gap-6___xzEzH`,
	"gap8": `CGMIndicator-module__gap-8___5aLEU`,
	"gap10": `CGMIndicator-module__gap-10___djpbf`,
	"gap12": `CGMIndicator-module__gap-12___i1UhS`,
	"gap14": `CGMIndicator-module__gap-14___awzzt`,
	"gap16": `CGMIndicator-module__gap-16___YwyR4`,
	"gap18": `CGMIndicator-module__gap-18___rQ_Ho`,
	"gap20": `CGMIndicator-module__gap-20___vY5pB`,
	"gap24": `CGMIndicator-module__gap-24___E22vV`,
	"gap26": `CGMIndicator-module__gap-26___nd8mf`,
	"gap30": `CGMIndicator-module__gap-30___ccrgR`,
	"gap32": `CGMIndicator-module__gap-32___uV0g6`,
	"gap40": `CGMIndicator-module__gap-40___oSP4U`,
	"gap50": `CGMIndicator-module__gap-50___2DYFu`,
	"flex1": `CGMIndicator-module__flex-1___MA6In`,
	"flexNone": `CGMIndicator-module__flex-none___qiAz1`,
	"flexColumn": `CGMIndicator-module__flex-column___gCieW`,
	"flexRow": `CGMIndicator-module__flex-row___hGaOQ`,
	"verticallyCentered": `CGMIndicator-module__vertically-centered___xOBPS`,
	"horizontallyCentered": `CGMIndicator-module__horizontally-centered___bJxFh`,
	"horizontallyEnd": `CGMIndicator-module__horizontally-end___e4OGx`,
	"verticallyStart": `CGMIndicator-module__vertically-start___dkb3p`,
	"spaceBetween": `CGMIndicator-module__space-between___uTTxx`,
	"flexWrap": `CGMIndicator-module__flex-wrap___W8r0m`,
	"height100": `CGMIndicator-module__height-100___xhhu0`,
	"width50": `CGMIndicator-module__width-50___X4pZm`,
	"width100": `CGMIndicator-module__width-100___vz5j7`,
	"cursorPointer": `CGMIndicator-module__cursor-pointer___GrTTl`,
	"cursorNotAllowed": `CGMIndicator-module__cursor-not-allowed___ITs4U`,
	"absoluteCentered": `CGMIndicator-module__absolute-centered___NvNvx`,
	"absolute": `CGMIndicator-module__absolute___MeO2U`,
	"relative": `CGMIndicator-module__relative___WZbYJ`,
	"fixed": `CGMIndicator-module__fixed___aPBCJ`,
	"visible": `CGMIndicator-module__visible___MDmlz`,
	"invisible": `CGMIndicator-module__invisible___QeBmy`,
	"col90": `CGMIndicator-module__col-90___mx_dz`,
	"colAuto": `CGMIndicator-module__col-auto___b80SF`,
	"medicalTabs": `CGMIndicator-module__medical-tabs___wnwyF`,
	"medicalTableNew": `CGMIndicator-module__medical-table-new___qlTAJ`,
	"noPagination": `CGMIndicator-module__no-pagination___ox1H7`,
	"medicalTableEmpty": `CGMIndicator-module__medical-table-empty___iFVrZ`,
	"iconBtn": `CGMIndicator-module__icon-btn___AAws4`,
	"searchIcon": `CGMIndicator-module__search-icon___euzC2`,
	"disableSelect": `CGMIndicator-module__disable-select___Lzkhc`,
	"breakWord": `CGMIndicator-module__break-word___XifhK`,
	"popupClearBtn": `CGMIndicator-module__popup-clear-btn___m4AS1`,
	"scrollMB20": `CGMIndicator-module__scroll-m-b-20___W2I0U`,
	"container": `CGMIndicator-module__container___PmtLQ`,
	"critical": `CGMIndicator-module__critical___TCxdW`
};
module.exports = ___CSS_LOADER_EXPORT___;
